import type { ComponentChildren } from "preact";

export function formatSsmValue(type: string, value: string): ComponentChildren {
  if (type === "String" && (value.startsWith("{") || value.startsWith("["))) {
    try {
      const parsed = JSON.parse(value);
      return <pre>{JSON.stringify(parsed, null, 2)}</pre>;
    } catch {
      // Not valid JSON — fall through and render as plain text.
    }
  }
  return value;
}
